import { _ as __decorate, a as __metadata, B as BaseComponent, I as ItBreadcrumbItem } from '../it-breadcrumb-item-J_m-wwu0.js';
import { css, html } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import 'lit/directive.js';

var styles = css`.breadcrumb {
  --bsi-breadcrumb-background: transparent;
  --bsi-breadcrumb-border-radius: 0;
  --bsi-breadcrumb-divider: '/';
  --bsi-breadcrumb-divider-color: var(--bsi-color-border-secondary);
  --bsi-breadcrumb-divider-flipped: var(--bsi-breadcrumb-divider);
  --bsi-breadcrumb-font-size: var(--bsi-label-font-size);
  --bsi-breadcrumb-item-padding-x: var(--bsi-spacing-xs);
  --bsi-breadcrumb-link-color: var(--bsi-color-text-secondary);
  --bsi-breadcrumb-link-font-weight: var(--bsi-font-weight-solid);
  --bsi-breadcrumb-margin: var(--bsi-spacing-s);
  --bsi-breadcrumb-padding: var(--bsi-spacing-3xs);
  --bsi-breadcrumb-separator-color: var(--bsi-color-background-secondary);
  --bsi-breadcrumb-separator-spacing: var(--bsi-spacing-xxs);
}

/* stylelint-disable-next-line no-duplicate-selectors */
.breadcrumb {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: var(--bsi-breadcrumb-margin);
  padding: var(--bsi-breadcrumb-padding);
  background-color: var(--bsi-breadcrumb-background, transparent);
  list-style: none;
  font-size: var(--bsi-breadcrumb-font-size);
}
.breadcrumb.dark {
  --bsi-breadcrumb-background: var(--bsi-color-background-emphasis);
  --bsi-breadcrumb-link-color: var(--bsi-color-text-inverse);
  --bsi-breadcrumb-item-active-color: var(--bsi-color-text-inverse);
  --bsi-breadcrumb-divider-color: var(--bsi-color-text-inverse);
}
.breadcrumb.dark .breadcrumb-item a:hover {
  --bsi-breadcrumb-link-color: var(--bsi-color-text-inverse);
}
.breadcrumb.dark .breadcrumb-item .separator {
  color: var(--bsi-breadcrumb-link-color);
}

.breadcrumb-item {
  padding-left: 0;
}
.breadcrumb-item + .breadcrumb-item::before {
  content: var(--bsi-breadcrumb-divider, escape-svg("/")) /* rtl: var(--bsi-breadcrumb-divider, escape-svg("/")) */;
  padding-right: var(--bsi-breadcrumb-item-padding-x);
  float: left;
  color: var(--bsi-breadcrumb-divider-color);
}
.breadcrumb-item + .breadcrumb-item:before {
  display: none;
}
.breadcrumb-item a {
  color: var(--bsi-breadcrumb-link-color);
  font-weight: var(--bsi-breadcrumb-link-font-weight);
}
.breadcrumb-item a:hover {
  --bsi-breadcrumb-link-color: var(--bsi-color-link-secondary-hover);
}
.breadcrumb-item.active {
  color: var(--bsi-breadcrumb-item-active-color);
  font-weight: var(--bsi-font-weight-regular);
  pointer-events: none;
}
.breadcrumb-item .separator {
  display: inline-block;
  padding: 0 var(--bsi-breadcrumb-separator-spacing);
  color: var(--bsi-breadcrumb-separator-color);
}

.breadcrumb.dark {
  --bsi-breadcrumb-padding: var(--bsi-spacing-3xs) var(--bsi-spacing-s);
}
.breadcrumb.dark ::slotted(it-breadcrumb-item) {
  --bsi-breadcrumb-link-color: #fff;
  --bsi-breadcrumb-item-active-color: #fff;
  --bsi-breadcrumb-separator-color: #fff;
}`;

/**
 * Simple breadcrumbs component following repository conventions.
 * - Renders a list of slotted anchors or items
 * - Dark mode variant
 */
let ItBreadcrumb = class ItBreadcrumb extends BaseComponent {
    constructor() {
        super(...arguments);
        this.itAriaLabel = 'Breadcrumbs';
        this.separator = '/';
        this.dark = false;
    }
    _setChildrenProperties() {
        const slot = this.shadowRoot?.querySelector('slot');
        const assignedElements = slot?.assignedElements({ flatten: true }) || [];
        assignedElements.forEach((el, index) => {
            if (el instanceof ItBreadcrumbItem) {
                const current = index === assignedElements.length - 1;
                el.setCurrent(current);
                el.setSeparator(this.separator);
                // No need for requestUpdate() because current and separator are reactive @state() properties
            }
        });
    }
    render() {
        const olClasses = this.dark ? 'breadcrumb dark' : 'breadcrumb';
        return html `
      <nav aria-label="${this.itAriaLabel}" part="breadcrumbs-container" class="breadcrumb-container">
        <ol class="${olClasses}" part="breadcrumbs">
          <slot @slotchange=${this._setChildrenProperties}></slot>
        </ol>
      </nav>
    `;
    }
};
ItBreadcrumb.styles = styles;
__decorate([
    property({ type: String, reflect: true, attribute: 'it-aria-label' }),
    __metadata("design:type", Object)
], ItBreadcrumb.prototype, "itAriaLabel", void 0);
__decorate([
    property({ type: String, reflect: true }),
    __metadata("design:type", Object)
], ItBreadcrumb.prototype, "separator", void 0);
__decorate([
    property({ type: Boolean, reflect: true }),
    __metadata("design:type", Object)
], ItBreadcrumb.prototype, "dark", void 0);
ItBreadcrumb = __decorate([
    customElement('it-breadcrumbs')
], ItBreadcrumb);

export { ItBreadcrumb };
//# sourceMappingURL=it-breadcrumbs.js.map
